import { WEBSITES_SAVE_TO_LIST_SELECTION_TOP_N_VALUES } from "app/pages/sales-intelligence/sub-modules/opportunities/models/save-to-list-selection/constants";
import createSaveToListSelectionDropdown from "app/pages/sales-intelligence/sub-modules/opportunities/models/save-to-list-selection/factory";

import type SelectionDropdown from "../../../../table-actions-panel/models/selection-dropdown/SelectionDropdown";

const saveToListSelectionDropdown: SelectionDropdown = createSaveToListSelectionDropdown({
    topNValues: WEBSITES_SAVE_TO_LIST_SELECTION_TOP_N_VALUES,
});

export default saveToListSelectionDropdown;
